module.exports = __webpack_public_path__ + "static/img/矢量智能对象2.0e9467c2.png";